module.exports = __webpack_public_path__ + "static/media/Mudkip_gaussian2.03d45879.png";